import { api } from "@/api";
import { QueryProps } from "@/types/Api";
import { BettingMarketMappingDto } from "@/types/ApiResponses/BettingMarket";

export interface GetBettingMarketMappingsParams {
  providerId?: number;
}

export const getBettingMarketMappings = async (
  marketId: number,
  props: QueryProps<GetBettingMarketMappingsParams>
): Promise<BettingMarketMappingDto[]> => {
  const res = await api.client.get(`/betting-markets-new/${marketId}/mappings`, {
    signal: props.signal,
    params: props.params,
  });
  return res.data;
};
